import React, { useState } from 'react';
import './ShippingForm.css'; // Include the CSS for styling

const ShippingForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    contactMethod: '',
    vehicleID: '',
    vin: '',
    make: '',
    model: '',
    year: '',
    purchaseDate: '',
    destinationCountry: '',
    shippingType: '',
    shippingPreference: '',
    additionalInstructions: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Shipping Request Submitted:', formData);
    alert('Your shipping request has been submitted successfully.');
  };

  return (
    <div class="shipping-form-container1">
      <h1>Complete the Shipping Request Form</h1>
      <p>
        Please fill out the form below to submit your shipping request. Once submitted, our team will contact you with a shipping quote and the next steps.
      </p>
      <form class="shipping-form1" onSubmit={handleSubmit}>
        {/* Personal Information */}
        <fieldset>
          <legend>1. Personal Information</legend>
          <label>
            Full Name:
            <input
              type="text"
              name="fullName"
              class="inputclass"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Email Address:
            <input
              type="email"
              class="inputclass"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Phone Number:
            <input
              type="tel"
              name="phone"
              class="inputclass"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Preferred Contact Method:
            <select
              name="contactMethod"
              value={formData.contactMethod}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Email">Email</option>
              <option value="Phone Call">Phone Call</option>
              <option value="Text Message">Text Message</option>
            </select>
          </label>
        </fieldset>

        {/* Vehicle Information */}
        <fieldset>
          <legend>2. Vehicle Information</legend>
          <label>
            Vehicle ID (Lot or Stock #):
            <input
              type="text"
              name="vehicleID"
              class="inputclass"
              value={formData.vehicleID}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            VIN:
            <input
              type="text"
              name="vin"
              class="inputclass"
              value={formData.vin}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Make:
            <input
              type="text"
              name="make"
              class="inputclass"
              value={formData.make}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Model:
            <input
              type="text"
              name="model"
              class="inputclass"
              value={formData.model}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Year:
            <input
              type="number"
              name="year"
              class="inputclass"
              value={formData.year}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Date of Purchase:
            <input
              type="date"
              name="purchaseDate"
              class="inputclass"
              
              value={formData.purchaseDate}
              onChange={handleChange}
              required
            />
          </label>
        </fieldset>

        {/* Delivery Information */}
        <fieldset>
          <legend>3. Delivery Information</legend>
          <label>
            Destination Country:
            <select
              name="destinationCountry"
              value={formData.destinationCountry}
              onChange={handleChange}
              required
            >
              <option value="">Select Country</option>
              <option value="USA">USA</option>
              <option value="Canada">Canada</option>
              <option value="UK">UK</option>
              <option value="Australia">Australia</option>
              <option value="Other">Other</option>
            </select>
          </label>
        </fieldset>

        {/* Shipping Options */}
        <fieldset>
          <legend>4. Shipping Options</legend>
          <label>
            Preferred Shipping Type:
            <select
              name="shippingType"
              value={formData.shippingType}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="RORO">RORO</option>
              <option value="LCL Container">LCL Container</option>
              <option value="FCL Container">FCL Container</option>
            </select>
          </label>
          <label>
            Shipping Preferences:
            <select
              name="shippingPreference"
              value={formData.shippingPreference}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Grimaldi">Grimaldi</option>
              <option value="ACL (Grimaldi)">ACL (Grimaldi)</option>
              <option value="RORO">RORO</option>
              <option value="Container Shipping">Container Shipping</option>
              <option value="Other">Other</option>
            </select>
          </label>
          <label>
            Additional Instructions or Requests:
            <textarea
              name="additionalInstructions"
              value={formData.additionalInstructions}
              onChange={handleChange}
              placeholder="E.g., Please deliver after 5 PM"
            />
          </label>
        </fieldset>

        <button type="submit" class="submit-button1">
          Submit Request
        </button>
      </form>

      <div class="contact-section1">
        <h2>Need Assistance?</h2>
        <p>
          Phone: <a href="tel:1-800-123-4567">1-800-123-4567</a>
          <br />
          Email: <a href="mailto:shipping@automotorauctions.com">shipping@automotorauctions.com</a> or{' '}
          <a href="mailto:info@automotorauctions.com">info@automotorauctions.com</a>
          <br />
          Live Chat: Available Monday to Friday from 9 AM to 6 PM
        </p>
      </div>
    </div>
  );
};

export default ShippingForm;
